import React from 'react';
import { Text, Center } from '@chakra-ui/react'

import useTranslations from "../../hooks/useTranslations";

export type SelectNoOptionsMessageProps = {
  message?: string;
}

const SelectNoOptionsMessage: React.FC<SelectNoOptionsMessageProps> = ({ message }) => {
  const t = useTranslations();

  return (
    <Center>
      <Text>
        {message || t("select.noOptionsMessage")}
      </Text>
    </Center>
  );
}

export default React.memo(SelectNoOptionsMessage);
